import type { FunctionComponent } from "react";
import { useState } from "react";
import { graphql, useFragment } from "react-relay";

import { acknowledgementGateArticleIds } from "~/data";
import { useEditionValue } from "~/lib/edition";
import { useGetHomeAsPath } from "~/lib/router/hooks";
import { page as HomePage } from "~/pages/home";
import type { articleAcknowledgementGateOverlayArticle$key } from "~/queries/__generated__/articleAcknowledgementGateOverlayArticle.graphql";

import {
  Container,
  ContentBody,
  ContentBodyText,
  ContentContainer,
  ContentFooter,
  StyledAnchor,
  StyledBaseLink,
  StyledLogo,
  StyledLogoFlag,
  StyledLogoText,
} from "./styles";

export type Props = {
  reference: articleAcknowledgementGateOverlayArticle$key;
};

export const ArticleAcknowledgementGateOverlay: FunctionComponent<Props> = ({
  reference: reference_,
}) => {
  const { entityId: currentArticleId } = useFragment(
    graphql`
      fragment articleAcknowledgementGateOverlayArticle on Article {
        entityId
      }
    `,
    reference_,
  );

  const edition = useEditionValue();
  const homeAsPath = useGetHomeAsPath();
  const [acknowledgementAccepted, setAcknowledgementAccepted] = useState(false);
  const { pathname: homePagePathname } = HomePage.route({
    edition,
    slide: "main",
  });

  const isAcknowledgementRequired =
    acknowledgementGateArticleIds.has(currentArticleId) && !acknowledgementAccepted;

  return (
    <>
      {isAcknowledgementRequired && (
        <Container>
          <ContentContainer>
            <StyledLogo as={homeAsPath} pathname={homePagePathname}>
              <StyledLogoFlag />
              <StyledLogoText />
            </StyledLogo>
            <ContentBody>
              <ContentBodyText>
                <b>Update:</b> A Canadian Tribunal has ruled that China’s allegations against
                Michael Ching have not been established, putting him on the path to Canadian
                citizenship.
              </ContentBodyText>
              <ContentBodyText>
                The article you searched was the subject of a defamation claim by Michael Ching
                against the SCMP, resolved by a settlement requiring readers to acknowledge
                subsequent Canadian developments.
              </ContentBodyText>
              <ContentBodyText>
                To read more about those developments, click{" "}
                <StyledAnchor href="https://sc.mp/acknowledge" target="_blank">
                  here
                </StyledAnchor>
                .
              </ContentBodyText>
              <ContentBodyText>
                Click{" "}
                <StyledAnchor onClick={() => setAcknowledgementAccepted(true)}>here</StyledAnchor>{" "}
                to acknowledge you’ve read this update.
              </ContentBodyText>
            </ContentBody>
            <ContentFooter>
              <StyledBaseLink as={homeAsPath} pathname={homePagePathname}>
                Back to SCMP.com
              </StyledBaseLink>
            </ContentFooter>
          </ContentContainer>
        </Container>
      )}
    </>
  );
};

ArticleAcknowledgementGateOverlay.displayName = "ArticleAcknowledgementGateOverlay";
